// extracted by mini-css-extract-plugin
module.exports = {"programSection":"program-module--programSection--37i2W","cardGrid":"program-module--cardGrid--1ux-p","title":"program-module--title--3eUit"};